import React, {useEffect, useContext} from "react";
import BasicView from "../../components/BasicView";
import {HeadSuscribe} from "../../styles/HeadsVies";
import {SecondView} from "../../styles/HeadView";
import SuscribeModal from "./SuscribeModal";
import PageNotFound from "../others/PageNotFound";
import {ThemaryComponent, ProfileComponent, ResourceLirary, NextCourses} from "./components/DetailsComponents";
import FacilitadorSection from "./components/FacilitadorSection";
import ExperienceSection from "./components/ExperienceSection";
import MediaSection from "./components/MediaSection";
import FloatButton from "./components/FloatButton";
import {useParams} from "react-router-dom";
import {CoursesContext} from "../../context/CoursesContext";
import {LoadComponet} from "../../components/loaders/Loader";
import {isMobile} from "../../constants/Helpers";

export default function CourseDetails() {
   const {getInfoCourse, courseData, getInfoFacilitators, listWebFacilitators} = useContext(CoursesContext);
   const {id} = useParams();

   useEffect(() => {
      getInfoFacilitators();
   }, []);

   useEffect(() => {
      getInfoCourse(id);
   }, [id]);

   useEffect(() => {
      let nTitle = courseData.courseName ? courseData.courseName + " - Domecq Academy" : "Domecq Academy";
      document.title = nTitle;
      return () => {
         document.title = "Domecq Academy";
      };
   }, [id]);

   if (courseData.isLoading) return <LoadComponet isVisible={true} />;
   if (!courseData) return <PageNotFound />;
   return (
      <>
         <BasicView
            imageBack={`http://domecqapi.trebolbit.com/${isMobile ? courseData.pathImageMobile : courseData.pathImageDesktop}`}
            isSecondary={true}
         >
            <HeadSuscribe data={courseData} titulo="titulo 1" nomre />
            <SecondView>
               <ThemaryComponent />
               {!listWebFacilitators.isLoading && <FacilitadorSection />}
               <ProfileComponent />
               <NextCourses />
               <ResourceLirary />
               <MediaSection courseType={courseData.idCourseType} />
               <ExperienceSection
                  title="Mi experiencia en domecq academy"
                  text="Te invitamos a conocer lo que opinan nuestros agresados y a escuchar de viva voz como Domecq Academy los ha ayudado a impulsar su desarrollo profesional"
               />
               <FloatButton action={() => console.log("actin")} />
            </SecondView>
         </BasicView>
         <SuscribeModal url={courseData.linkEventBrite} />
      </>
   );
}
